import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getParticipantLeaderboardStart } from "../../redux/quizathon/reducer";
import {
  selectIsLoadingParticipantLeaderboard,
  selectParticipantLeaderboard,
} from "../../redux/quizathon/selectors";

const useParticipantLeaderboard = ({ studentId ,quizathonId}) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoadingParticipantLeaderboard);
  const participantLeaderboard = useSelector(selectParticipantLeaderboard);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);

  const getParticipantLeaderboard = useCallback(() => {
    if (!studentId) return;
    dispatch(getParticipantLeaderboardStart({studentId,quizathonId}));
  }, [dispatch, studentId ,quizathonId]);

  useEffect(() => {
    if (!studentId) return;
    getParticipantLeaderboard();
  }, [studentId, getParticipantLeaderboard, fetch ,quizathonId]);

  return {
    participantLeaderboard,
    loadingParticipantLeaderboard: isLoading,
    refetch,
  };
};

export default useParticipantLeaderboard;
